export const MonitoringEvents = {
  // Document events
  DOCUMENT_GENERATION_TEMPLATE_REQUESTED: 'DocumentGenerationTemplateRequested',
  DOCUMENT_GENERATION_REQUEST_CREATED: 'DocumentGenerationRequestCreated',
  DOCUMENT_GENERATION_COMPLETED: 'DocumentGenerationCompleted',
  DOCUMENT_RETRIEVAL_SUCCESS: 'DocumentRetrievalSuccess',
  DOCUMENT_RETRIEVAL_FAILED: 'DocumentRetrievalFailed',
  BULK_DOCUMENT_DOWNLOAD_SUCCESS: 'BulkDocumentDownloadSuccess',
  BULK_DOCUMENT_DOWNLOAD_FAILED: 'BulkDocumentDownloadFailed',
  
  // Borrowing capacity events
  BORROWING_CAPACITY_CALCULATION_STARTED: 'BorrowingCapacityCalculationStarted',
  BORROWING_CAPACITY_CALCULATION_COMPLETED: 'BorrowingCapacityCalculationCompleted',
  PRODUCT_SELECTION_BORROWING_CAPACITY_CALCULATION_STARTED: 'ProductSelectionBorrowingCapacityCalculationStarted',
  PRODUCT_SELECTION_BORROWING_CAPACITY_CALCULATION_COMPLETED: 'ProductSelectionBorrowingCapacityCalculationCompleted',
  
  // Page load time events
  BORROWING_CAPACITY_PAGE_LOAD_TIME: 'BorrowingCapacityPageLoadTime',
  FUNDS_POSITION_PAGE_LOAD_TIME: 'FundsPositionPageLoadTime',
  PRODUCT_SELECTION_PAGE_LOAD_TIME: 'ProductSelectionPageLoadTime',
  
  // Opportunity lifecycle events (Creation actions)
  OPPORTUNITY_CREATED: 'OpportunityCreated',
  OPPORTUNITY_COPIED: 'OpportunityCopied',
  
  // Opportunity workflow status transitions (State-based)
  OPPORTUNITY_SUBMITTED: 'OpportunitySubmitted',
  OPPORTUNITY_READY_TO_ASSESS: 'OpportunityReadyToAssess',
  OPPORTUNITY_PRE_APPROVED: 'OpportunityPreApproved',
  OPPORTUNITY_APPROVED: 'OpportunityApproved',
  OPPORTUNITY_SETTLED: 'OpportunitySettled',
  
  // Opportunity user actions (Action-based)
  OPPORTUNITY_AMENDED: 'OpportunityAmended',
  OPPORTUNITY_WITHDRAWN: 'OpportunityWithdrawn',
  OPPORTUNITY_EXTRA_DOCUMENTS_SUBMITTED: 'OpportunityExtraDocumentsSubmitted',
  
  // Business-specific events
  SUBMISSION_STARTED: 'SubmissionStarted',
  SUBMISSION_FAILED: 'SubmissionFailed',
  SETTLEMENT_SCHEDULED: 'SettlementScheduled',
  SETTLEMENT_PRODUCT_RESOLUTION_FAILED: 'SettlementProductResolutionFailed',
  FEE_WAIVED: 'FeeWaived'
} as const;

